import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerRetirementOfPeriod: [
    'procedureId',
    'reason',
    'detail',
    'contact',
    'idDetail2',
    'detail2',
    'period',
    'career'
  ],
  // Reducer
  registerRetirementOfPeriodClear: null,
  registerRetirementOfPeriodRequest: null,
  registerRetirementOfPeriodSuccess: null,
  registerRetirementOfPeriodFailure: ['error']
});

export { Creators, Types };
